import { Component } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';
import { TenantConfig } from 'src/app/services/tenant/tenant-config';
import { TenantService } from 'src/app/services/tenant/tenant.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  public tenant: TenantConfig;

  constructor(
    private notify: NotificationService,
    private tenantService: TenantService
  ) {
    this.tenant = this.tenantService.getTenant();
  }

  n() {
    this.notify.notify({
      type: 'error',
      title: 'E1 Error',
      text: 'erro mesage',
      callback: function(e) {
        console.log(e);
      }
  })
  }
}
